// const extractCode = lotName => {
//   return lotName.match(/_(P|PFW|FWP)(?=_|$)/)?.[1] || '';
// };
const extractCode = lotName => {
  return lotName.match(/(?:^|_)([PWF]+)(?=_|$)/i)?.[1] || 'N/A';
};

export default extractCode;
